<template>
    <div class="about-us">
        <menuBox :step="3"></menuBox>
        <div class="title-box">About Us</div>

        <div class="us-box">
            <div class="title">Explore Our Story</div>
            <img src="../assets/home_2.png" class="sbtitle">

            <div class="number-list">
                <div class="number-item">
                    <img src="../assets/number-1.png" alt="">
                    <div class="number-box">
                        <div>10+</div>
                        <p>Years of Industry Experience</p>
                    </div>
                </div>
                <div class="number-item">
                    <img src="../assets/number-2.png" alt="">
                    <div class="number-box">
                        <div>100+</div>
                        <p>Successful Cases</p>
                    </div>
                </div>
                <div class="number-item">
                    <img src="../assets/number-3.png" alt="">
                    <div class="number-box">
                        <div>20+</div>
                        <p>Team of Over 20 Experts</p>
                    </div>
                </div>
            </div>

            <div class="optime-box">
                <div class="text-opts">
                    <div class="opt-title">Our Commitment</div>
                    <div class="opt-text-1">We are committed to providing our clients with outstanding service and innovative solutions to achieve their business goals and exceed expectations.</div>
                    <div class="text-img">
                        <img src="../assets/us-1.png" alt="">
                        <div class="text-box">
                            <div>Exceptional Customer Service</div>
                            <p>Putting our clients at the heart of everything we do, we maintain agility and respond promptly to ensure they receive the best support and satisfaction.</p>
                        </div>
                    </div>
                    <div class="text-img">
                        <img src="../assets/us-1.png" alt="">
                        <div class="text-box">
                            <div>Continuous Innovation and Improvement</div>
                            <p>We relentlessly pursue innovation and improvement, continuously refining our methods and processes to ensure we stay at the forefront of the industry.</p>
                        </div>
                    </div>
                </div>
                <img src="../assets/us-3.png" alt="">
            </div>
        </div>

        <div class="here-box">
            <div class="title">Milestones and Achievements</div>
            <img src="../assets/home_2.png" class="sbtitle">

            <div class="here-list">
                <div class="here-item">
                    <div>Inception</div>
                    <p>Our story began with a shared vision and dedication among a group of like-minded professionals. With a commitment to providing clients with the highest quality of service and solutions, we embarked on our journey.</p>
                    <div>2023/2/12</div>
                    <img src="../assets/us-4.png" alt="">
                </div>
                <div class="here-item">
                    <div>Sustained Growth</div>
                    <p>As time progressed, we continued to expand our team and refine our services and processes. Our sustained growth is a testament to our commitment and a reflection of the trust our clients place in us.</p>
                    <div>2023/2/12</div>
                    <img src="../assets/us-5.png" alt="">
                </div>
                <div class="here-item">
                    <div>Industry Leadership</div>
                    <p>Today, we have established ourselves as leaders in the industry, earning widespread recognition and acclaim. We take pride in our clients' success and strive for excellence, constantly enhancing our services to better serve them.</p>
                    <div>2023/2/12</div>
                    <img src="../assets/us-6.png" alt="">
                </div>
            </div>
        </div>

        <footerBox :step="3"></footerBox>
    </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            ask_1: false,
            ask_2: false,
            ask_3: false,
            ask_4: false,
            ask_5: false,
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>


<style lang="less" scoped>
.title {
    font-weight: 600;
    font-size: 58px;
    color: #333333;
}

.sbtitle {
    width: 305px;
    margin: auto;
    margin-top: 20px;
}


.title-box {
    height: 512px;
    background-image: url(../assets/title-box.png);
    background-size: 100% 100%;
    font-weight: 500;
    font-size: 75px;
    color: #040F1C;
    display: flex;
    align-items: center;
    justify-content: center;
}

.us-box {
    padding: 120px 360px;
    text-align: center;

    .number-list {
        margin-top: 80px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .number-item {
            display: flex;
            align-items: flex-start;
            justify-content: center;
            text-align: left;
            width: 300px;

            img {
                width: 54px;
            }

            .number-box {
                margin-left: 24px;

                div {
                    font-weight: 600;
                    font-size: 50px;
                    color: #333333;
                }

                p {
                    font-weight: 400;
                    font-size: 20px;
                    color: rgba(51, 51, 51, 0.8);
                }
            }
        }
    }

    .optime-box {
        margin-top: 120px;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;

        img {
            width: 595px;
        }

        .text-opts {
            text-align: left;
            width: 600px;

            .opt-title {
                font-weight: bold;
                font-size: 52px;
                color: #333333;
            }

            .opt-text-1 {
                font-weight: 400;
                font-size: 20px;
                color: rgba(51, 51, 51, 0.8);
                margin-top: 10px;
            }

            .text-img {
                display: flex;
                align-items: center;
                // justify-content: space-between;
                margin-top: 40px;

                img {
                    width: 87px;
                }

                .text-box {
                    margin-left: 20px;

                    div {
                        font-weight: 500;
                        font-size: 24px;
                        color: #333333;
                    }

                    p {
                        font-weight: 400;
                        font-size: 20px;
                        color: #999999;
                    }
                }
            }
        }
    }
}

.here-box {
    padding: 120px 360px;
    text-align: center;

    .here-list {
        margin-top: 120px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .here-item {
            width: 279px;
            height: 390px;
            background: #EFF7F5;
            border-radius: 0px 0px 0px 0px;
            padding: 70px 30px;
            text-align: left;
            position: relative;

            div {
                font-weight: 500;
                font-size: 30px;
                color: #333333;
            }

            p {
                font-weight: 400;
                font-size: 16px;
                color: #999999;
                padding: 34px 0px;
                // min-height: 170px;
            }

            img {
                width: 126px;
                // float: inline-end;
                // margin-top: -10px;
                position: absolute;
                bottom: -20px;
                right: -20px;
            }
        }
    }
}
</style>